module.exports = __webpack_public_path__ + "img/image4.e986fc50.png";